export enum ESharedComponent {
    "AppContainer",
    "ActivePanel",
    "AmbienceMenu",
    "BottomBar",
    "Calendar",
    "DeepWorkKipsToday",
    "Diversity",
    "Dreams",
    "DreamEditor",
    "DreamsNavigationLink",
    "GameIdentityScores",
    "GoalEditorPanel",
    "GoalsContainer",
    "GoalCards",
    "GoalsNavigationLink",
    "Header",
    "Hero",
    "HomeContainer",
    "LogInputForm",
    "LevelProgressBar",
    "Log",
    "LogMonumental",
    "Login",
    "MusicMenu",
    "NavigationMenu",
    "SearchNodes",
    "SoundMasterMenu",
    "States",
    "Statistics",
    "StatusBar",
    "TodaysProgressBar",
    "TodaysTime",
    "Tools",
    "Workflows",
}
